<template>
  <div class="tabs" :style="{ width: '100%' }">
    <div
      class="tabs-item"
      style="margin-right: 129px"
      @click="changeTabs('Home')"
    >
      <img src="@/assets/img/形状_65_拷贝.png" alt="" v-if="name == 'Home'" />
      <img src="@/assets/img/形状_65_拷贝_2.png" alt="" v-else />
      <p :style="{ color: name == 'Home' ? '#EA4949' : '#999999' }">首页</p>
    </div>
    <div class="tabs-item" @click="changeTabs('My')">
      <img src="@/assets/img/形状_39_拷贝.png" alt="" v-if="name == 'My'" />
      <img src="@/assets/img/形状_39.png" alt="" v-else />
      <p :style="{ color: name == 'My' ? '#EA4949' : '#999999' }">我的</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      return this.$route.name;
    },
  },
  methods: {
    changeTabs(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="less" scoped>
.tabs {
  position: fixed;
  bottom: 0;
  height: 76px;
  background: #ffffff;
  box-shadow: 0px 3px 15px 0px rgba(107, 107, 107, 0.23);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  .tabs-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 18px;
      height: 18px;
      margin-bottom: 6px;
    }
    p {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      margin-bottom: 0;
    }
  }
}
</style>